import qs from 'qs'
import { useRouterHistory } from 'react-router'
import { createHistory, useBeforeUnload } from 'history'

// based off https://github.com/mjackson/history/pull/171
function stringifyQuery(query) {
  return qs.stringify(query, { arrayFormat: 'brackets' }).replace(/%20/g, '+')
}

function parseQueryString(queryString) {
  return qs.parse(queryString.replace(/\+/g, '%20'))
}

export const appHistory = useBeforeUnload(useRouterHistory(createHistory))({
  stringifyQuery,
  parseQueryString,
})



// WEBPACK FOOTER //
// ./src/scripts/app/RouterHelpers.js